import useGridConfig from '../hooks/use-grid-config'
import STAFF from '@/app/config/staff'

export type Column = {
    width: number
    stack: typeof STAFF
    usedUpToStaff: number
    offsetClass: string
}

const getOffsetClassNameByIndex = (index: number) => {
    const offsets = ['mt-0', 'mt-20', 'mt-10']

    return offsets[index % offsets.length]
}

const buildGridColumn = (gridConfig: ReturnType<typeof useGridConfig>, items: typeof STAFF, staffStartIndex: number, columnIndex: number): Column => {
    const width = gridConfig.columnWidths[columnIndex % gridConfig.columnWidths.length]
    const h = gridConfig.columns[columnIndex % gridConfig.columns.length]

    const stack: typeof STAFF = []
    for (let i = 0; i < h; i++) {
        stack.push(items[staffStartIndex % items.length])
        staffStartIndex++
    }

    return {
        width,
        stack,
        usedUpToStaff: staffStartIndex,
        offsetClass: getOffsetClassNameByIndex(columnIndex)
    }
}

export default buildGridColumn
